import { makeModule } from '@codium/codium-vue'

export const storeModule = makeModule('mediaOwnerTags', {
  parent: 'lists'
})
